import { useEffect } from 'react';

import store from '../store';
import { setAccountIndex } from './account';
import { isNowPage } from './now';

/**
 * Should the app use the global nav.  Use this when
 * your component just wants to know, and doesn't expect
 * to drop an `xc-*` element.
 */
export const useIsGlobalNav = () => true;
export const isGlobalNavForClassComp = () => true;

const HAS_CUSTOM = !!window.customElements;
export const continuePageLoad = () => {
  isReady = true;
};

let isReady = false;
let polarisScript = null;
/**
 * Should the app use the global nav.  Use this when
 * your component expects to drop an `xc-*` element.
 */
export const usePolaris = () => {
  useEffect(() => {
    const checkAccount = () => {
      // We've already seen this through to completion; skip
      if (isReady) return null;
      const polaris = document.querySelector('xc-header')?.data?.polaris;
      // Get the macaroon and its load state from the store
      const { macaroon: { accounts } = {}, loading } = store.getState().auth || {};
      // Macaroon or Polaris is still loading; skip
      if (loading || !polaris?.user) return null;
      // Get the expected account number from Polaris
      const polarisAccount = polaris?.user?.accountNumber;
      // Get the expected account number from the store
      const myAccount = (
        accounts?.find(({ isSelectedAccount }) => isSelectedAccount)?.accountNumber
      );
      // Polaris and Macaroon are ready, but there's no account on one or the other
      // Either we'll be redirected to login, or there's an error page, either way
      // show the page and clean up.
      if (!polarisAccount || !myAccount) return cleanup();
      // Accounts match; show the page
      if (myAccount === polarisAccount) return cleanup();
      // Accounts don't match; find and set the correct account index and reload
      // Loading Screen will display again
      setAccountIndex(accounts.findIndex(({ accountNumber }) => (
        accountNumber === polarisAccount
      )), false);
      window.location.reload();
      return null;
    };

    // Listen on changes to Polaris data
    window.addEventListener('polaris-data-changed', checkAccount);
    const unlisten = () => window.removeEventListener('polaris-data-changed', checkAccount);
    // Listen on changes to the Macaroon
    const unsubscribe = store.subscribe(checkAccount);
    const cleanup = () => {
      // Remove the listeners to ease overhead; the macaroon
      // account doesn't change between page loads, and once
      // polaris is ready, neither will it change.
      unlisten();
      unsubscribe();
      continuePageLoad();
    };

    if (!polarisScript) {
      const el = document.createElement('script');
      const domain = (
        window.MAW.env === 'prod'
        || window.MAW.env === 'preprod'
      )
        ? 'https://polaris.xfinity.com/'
        : 'https://polaris.staging.xfinity.com/';
      const { pathname } = window.location;
      let path = 'globalnav/';
      if (isNowPage(pathname)) {
        path = 'now/';
      }

      const file = `polaris.${HAS_CUSTOM ? 'wc' : 'es5'}.js`;
      el.setAttribute('async', 'async');
      el.src = `${domain}${path}${file}`;
      el.crossOrigin = 'anonymous';
      polarisScript = el;
      document.querySelector('head').appendChild(el);
    }
  }, []);

  return true;
};
